import { render, staticRenderFns } from "./dommages.vue?vue&type=template&id=63faba47"
import script from "./dommages.vue?vue&type=script&lang=ts"
export * from "./dommages.vue?vue&type=script&lang=ts"
import style0 from "./dommages.vue?vue&type=style&index=0&id=63faba47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports